<template>
  <div class="page-content">
    <div class="steps-box">
      <Steps :current="1">
        <Step
          title="提交订单"
        ></Step>
        <Step
          title="去支付"
        ></Step>
        <Step
          title="支付完成"
        ></Step>
      </Steps>
    </div>
    <div class="pay-box">
      <div class="form-section">
        <span class="form-section-name">选择支付方式</span>
        <span class="form-section-tip">
          （支付完成请在“我的订购”中自助开具电子发票）
        </span>
      </div>
      <div class="pay-section">
        <div
          v-for="(item,index) in pay.list"
          :key="index"
          :class="['pay-item',{select:index===pay.select}]"
          @click="pay.on.paySelect(index)"
        >
          <div>
            <img
              class="pay-item-icon"
              :src="item.icon"
            >
            <span class="pay-item-title">
              {{ item.title }}支付
              <span
                v-if="index===pay.select && pay.loading"
                class="pay-loading"
              >
                二维码生成中...
              </span>
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="qrcode.text"
        class="qrcode-section"
      >
        <img
          class="payWayImg"
          :src="pay.list[pay.select].payWayImg"
        >
        <div class="qrcode-box">
          <vue-qr
            class="qrcode"
            :logo-src="pay.list[pay.select].icon"
            :text="qrcode.text"
            :size="240"
          ></vue-qr>
          <div class="tip">
            请打开{{ pay.list[pay.select].title }}扫一扫功能 ，扫描二维码付款
          </div>
        </div>
      </div>
      <!-- 汇款支付 -->
      <div
        v-if="pay.select===2"
        class="remitMoney-section"
      >
        <div class="remitMoney-tip">
          请将订购款 
          <span class="pay-money">￥ 
            <span class="pay-money-value">1,0320.00</span>
          </span>
          汇至以下收款方银行账号，汇款完成后请仔细填写付款方信息
        </div>
        <div class="remitMoney-content">
          <div>
            <div class="remitMoney-section-name">
              收款方信息
            </div>
            <div class="remitMoney-info">
              <div class="remitMoney-info-item">
                收款方户名：浙江深大科技有限公司
              </div>
              <div class="remitMoney-info-item">
                收款方开户行：杭州银行西湖分行
              </div>
              <div class="remitMoney-info-item">
                收款方账号：49030040050503
                <span
                  class="copy-btn"
                  @click="copy(49030040050503)"
                >复制</span>
              </div>
            </div>
          </div>
          <div>
            <div class="remitMoney-section-name">
              付款信息
            </div>
            <MySubmitForm
              ref="form"
              v-model="remitMoney.params"
              class="form"
              :label-width="90"
              :form-items="remitMoney.formItems"
              cancel-text=""
              @on-submit="remitMoney.on.submit"
            >
            </MySubmitForm>
          </div>
        </div>
      </div>
      <div class="save-order">
        <span
          class="save-orde-btn"
          @click="goOrderRecord"
        > 保存订单，稍后再付</span>
      </div>
    </div>
  </div>
</template>
<script>
import {Steps,Step} from 'view-design';
import VueQr from 'vue-qr';
import MySubmitForm from '@/components/Template/SubmitForm';
import moment from 'moment';
export default {
  components: {
    Steps,
    Step,
    VueQr,
    MySubmitForm,
  },
  data(){
    return {
      pay: {
        select: '',
        loading: false,
        list: [
          {
            title: '微信',
            icon: require('@/assets/images/pay/icon1.png'),
            payWayImg: require('@/assets/images/pay/payWayImg1.png'),
          },
          {
            title: '支付宝',
            icon: require('@/assets/images/pay/icon2.png'),
            payWayImg: require('@/assets/images/pay/payWayImg1.png'),
          },
          {
            title: '汇款',
            icon: require('@/assets/images/pay/icon3.png'),
          },
        ],
        on: {
          paySelect: (index)=>{
            if (this.pay.loading){
              return;
            }
            this.pay.select = index;
            this.qrcode.text = '';
            if ([0,1].includes(index)){
              this.pay.loading = true;
              // 点击支付宝和微信时
              this.pay.loading = true;
             
              setTimeout(()=>{
                this.pay.loading = false;
                this.qrcode.text = '123456';
              },1000);
            } 
          },
        },
      },
      // 二维码
      qrcode: {
        text: '',
      },
      // 汇款支付
      remitMoney: {
        params: {},
        formItems: [
          {
            label: '付款户名',
            prop: 'merchantName',
            type: 'text',
            placeholder: ' 例如：浙江深大智能科技有限公司',
            rules: [
              { required: true, message: '请输入付款户名', trigger: 'blur' },
              { max: 50, message: '付款户名不超过50字符', trigger: 'blur' },
            ],
          },
          {
            label: '付款账号',
            prop: 'merchantName',
            type: 'text',
            placeholder: '请输入付款银行账号',
            rules: [
              { required: true, message: '请输入付款银行账号', trigger: 'blur' },
              { max: 50, message: '付款银行账号不超过50字符', trigger: 'blur' },
            ],
          },
          {
            label: '付款时间',
            prop: 'beginTime',
            type: 'date',
            placeholder: '请选择付款时间',
            format: 'yyyy-MM-dd',
            // options: {
            //   disabledDate: date => {
            //     let disabled = false;
            //     const { endTime } = this.tablePage.params;
            //     if (endTime) {
            //       if (date.getTime() > new Date(endTime).getTime()) {
            //         // 结束日期不得小于开始日期
            //         disabled = true;
            //       } else if (date.getTime() < new Date(endTime).getTime() - 30 * 24 * 60 * 60 * 1000) {
            //         // 结束日期与开始日期相差不超过30天
            //         disabled = true;
            //       }
            //     }

            //     return disabled;
            //   },
            // },
            on: {
              input: (date) => {
                if (!date) {
                  this.remitMoney.params.beginTime = '';
                  return;
                }
                this.remitMoney.params.beginTime = moment(date).format('YYYY-MM-DD');
              },
              // 'on-change': (date) => {
              //   this.tablePage.params.beginTime = date;
              // },
            },
            rules: [
              { required: true, message: '请选择付款时间', trigger: 'change' },
            ],
          },
        ],
        on: {
          submit: ()=>{
            this.$router.push({
              path: '/pay/payResult',
            });
          },
        },
      },
    };
  },
  computed: {
   
  },
  created(){
    // 支付方式
    this.getPay();
  },
  methods: {
    // 支付方式
    getPay() {
      // const url = '/paycenter-charge/api/facade/order/pay';
      const url = '/paycenter-charge/api/worktable/order/pay';
      const params = {
        orderNo: this.$route.query.orderNo,
      };
      this.$http.post(url,params).then(res => {
        if (res.success) {
          // this.detail = res.data; 
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    goOrderRecord(){
      this.$router.push({
        path: '/app/orderRecord/detail',
        query: {
          status: 1,
        },
      });
    },
    copy(value){
      this.$copyText(value).then(
        () => {
          this.$Message.success('复制成功！');
        },
        () => {
          this.$Message.error('复制失败！');
        },
      );
    },
  },
};
</script>
<style lang="less" scoped>
.page-content {
  background-color: #fff;
}
.steps-box {
  padding-top: 30px;
  width: 600px;
  margin: 0  auto 50px;
}
.pay-box {
  width: 800px;
  margin: 0  auto;
  padding-bottom: 40px;
}
.form-section {
  margin-bottom: 15px;
  .form-section-name {
    color: #333;
    font-weight: bold;
    font-size: 16px;
    margin-right: 10px;
  }
  .form-section-tip {
    color: #999;
    font-size: 12px;
    // padding-left: 20px;
  }
}
.pay-section {
  margin-bottom: 30px;
  .pay-item {
    color: #333;
    border: 1px solid #e0e0e0;
    padding: 5px 20px;
    border-radius: 5px;
    margin: 0 1.5%;
    position: relative;
    display: inline-block;
    width: 30%;
    .pay-item-icon {
      display: inline-block;
      vertical-align: middle;
      width: 64px;
      height: 64px;
    }
    .pay-item-title {
      position: relative;
      font-size: 16px;
      display: inline-block;
      vertical-align: middle;
    }
    .pay-loading {
      position: absolute;
      width: 100px;
      font-size: 12px;
      color: #999;
      bottom: -20px;
      left: 0;
    }
    &.select {
      border: 1px solid #409eff;
      background: #eef5fb;
      &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-bottom: 15px solid #409eff;
        border-left: 15px solid transparent;
        right: 0;
        bottom: 0;
      }
    }
  }
}
.qrcode-section {
  text-align: center;
  .payWayImg {
    height: 400px;
    vertical-align: middle;
  }
  .qrcode-box {
    display: inline-block;
    vertical-align: middle;
  }
  .tip {
    font-size: 12px;
    color: #999;
  }
}
.save-order {
  color: #409eff;
  text-align: center;
  padding-top: 20px;
  .save-orde-btn {
    cursor: pointer;
  }
}
.remitMoney-section {
  .remitMoney-content {
    width: 460px;
    margin: 0 auto;
  }
  .remitMoney-section-name {
    font-weight: bold;
    padding: 5px 0;
  }
  .remitMoney-tip {
    box-sizing: border-box;
    padding: 5px 20px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    margin-bottom: 20px;
  }
  .pay-money {
    color: #f00;
    font-weight: bold;
  }
  .pay-money-value {
    font-size: 18px;
  }
  .remitMoney-info-item {
    padding: 10px 0;
  }
  .copy-btn {
    color: #409eff;
  }
}
</style>